import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useIntl } from 'react-intl';
import { Input } from '@sonika-se/ui-kit/components';
import { Button } from '@sonika-se/ui-kit/components';
import { Field, Form, Text } from '@sonika-se/ui-kit/components';
const validationSchema = Yup.object().shape({
    password: Yup.string().required('Du måste ange ett lösenord'),
    newPassword: Yup.string()
        .required('Du måste ange ett lösenord')
        .oneOf([Yup.ref('password')], 'Lösenorden matchar inte'),
});
const UpdatePasswordForm = (props) => {
    var _a, _b, _c, _d;
    const { error = '', onSubmit, disabled, buttonText = 'Spara lösenord' } = props;
    const intl = useIntl();
    const { control, handleSubmit, formState: { errors }, } = useForm({
        resolver: yupResolver(validationSchema),
    });
    return (<Form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: '2rem' }}>
      <Field label={intl.formatMessage({ defaultMessage: 'Nytt lösenord', id: 'UpdatePasswordForm.password.label' })} error={(_b = (_a = errors === null || errors === void 0 ? void 0 : errors.password) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.toString()}>
        <Controller control={control} name="password" render={({ field }) => {
            var _a, _b;
            return (<Input error={(_b = (_a = errors === null || errors === void 0 ? void 0 : errors.password) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.toString()} onBlur={field.onBlur} onChange={field.onChange} type="password" disabled={disabled} value={field.value}/>);
        }}/>
      </Field>
      <Field label={intl.formatMessage({ defaultMessage: 'Upprepa lösenord', id: 'UpdatePasswordForm.new_password.label' })} error={(_d = (_c = errors === null || errors === void 0 ? void 0 : errors.newPassword) === null || _c === void 0 ? void 0 : _c.message) === null || _d === void 0 ? void 0 : _d.toString()}>
        <Controller control={control} name="newPassword" render={({ field }) => {
            var _a, _b;
            return (<Input disabled={disabled} error={(_b = (_a = errors === null || errors === void 0 ? void 0 : errors.newPassword) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.toString()} onBlur={field.onBlur} onChange={field.onChange} type="password" value={field.value}/>);
        }}/>
      </Field>
      <Button type="submit" size="large" style={{ width: '100%', marginTop: 16 }} disabled={disabled}>
        {buttonText}
      </Button>
      {error && <Text style={{ color: 'red' }}>{error}</Text>}
    </Form>);
};
export default UpdatePasswordForm;
